import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import createLogger from 'vuex/dist/logger'; // 修改日志

import login_store from './modules/login_store'
import serviceDemandDetail from './modules/serviceDemandDetail'
import warning from './modules/warning'
import login_id from './modules/login_id'

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    login: login_store,
    Detail: serviceDemandDetail,
    warning,
    login_id
  },
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js